export default __webpack_public_path__ + "static/media/ziyi.a6c42d3a.jpg";